import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Banner from '../banner/Banner';
import useUiAlerts from '../../stores/AlertsStore';

/** @typedef {import('../../stores/AlertsStore').Alert} Alert */

function Alerts({ ...otherProps }) {
    const [uiAlertState, uiAlertActions] = useUiAlerts();
    /** @type {[Alert, React.Dispatch<React.SetStateAction<Alert>>]} */
    const [currentAlert, setCurrentAlert] = useState(null);
    const location = useLocation();

    const isInitialPath = useRef(true);

    // Watch for current alert changes.
    useEffect(() => {
        setCurrentAlert(uiAlertState);
    }, [uiAlertState]);

    // Listening to navigation changes, we'll clear the alert when this happens.
    useEffect(() => {
        if (isInitialPath.current === true) {
            isInitialPath.current = false;
            return;
        }

        if (uiAlertState && uiAlertState.createOnNavigate) {
            uiAlertActions.queueDelayedAlert();
        } else {
            uiAlertActions.handleRemove();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    if (!currentAlert?.type || !currentAlert?.text) {
        return null;
    }

    return (
        <Banner
            type={currentAlert.type}
            text={currentAlert.text}
            onRemove={uiAlertActions.handleRemove}
            {...otherProps}
        />
    );
}

export default Alerts;
